import { TargetElementObserverError } from '../errors/TargetElementObserverError';
const isRectEqual = (a, b) => {
  return a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
};
const getElement = selector => {
  return document.querySelector(selector);
};
const getElementRect = element => {
  const boundingClientRect = element.getBoundingClientRect();
  return {
    top: boundingClientRect.top,
    left: boundingClientRect.left,
    width: boundingClientRect.width,
    height: boundingClientRect.height
  };
};
export const getSelectorsToElementRects = selectors => {
  const selectorsToElementRects = {};
  selectors.forEach(selector => {
    const element = getElement(selector);
    if (!element) {
      throw new TargetElementObserverError('Target element not found', {
        cause: {
          selector
        }
      });
    }
    selectorsToElementRects[selector] = getElementRect(element);
  });
  return selectorsToElementRects;
};
export const areTargetElementToRectsEqual = (targetElementsToRectsA, targetElementsToRectsB) => {
  const selectorsA = Object.keys(targetElementsToRectsA);
  const selectorsB = Object.keys(targetElementsToRectsB);
  if (selectorsA.length !== selectorsB.length) {
    return false;
  }
  return !selectorsA.some(selector => !isRectEqual(targetElementsToRectsA[selector], targetElementsToRectsB[selector]));
};